import { Component, OnInit } from '@angular/core';
import { StorageKeysEnum } from 'src/app/views/login/commons/config/storage-keys.enum';
import { UserHttp } from 'src/app/views/login/commons/http/user.http';
import { SessionHandlerService } from 'src/app/views/login/commons/services/session-handler.service';
import { IUser } from '../../interfaces/user.interface';

@Component({
  selector: 'pda-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  showMenu = false;

  user: IUser;

  constructor(private userHttp: UserHttp, private session: SessionHandlerService) { }

  ngOnInit(): void {
    this.getUser();
  }
  /**
   * getUser
   *
   * @description get the user from the sessionStorage
   */
  getUser(): void {
    const user = this.session.getUser();

    // if(this.session.isAuthenticated() && !user) {
    //   if(user) {

    //   }
    //   console.log(user);
    //   this.session.user$.subscribe(user => {
    //     this.user = user
    //   });
    // }
    if (user) {
      this.user = user;
    } else if (this.session.isAuthenticated()) {
      this.userHttp.getUser().subscribe( (usr: IUser) => {
        this.user = usr;
      });
    }
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

}
